import { HttpParams,  HttpClient,   HttpRequest } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { QuickDesign } from '../models/quick-design.model';
import { ActivatedRoute } from '@angular/router';

import 'rxjs/Rx';

import { APP_CONFIG } from '../app.config';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth.service';
import { Auth } from '../models/auth.model';

@Injectable()
export class QuickDesignService {
  quickDesignsChanged = new Subject<QuickDesign[]>();
  quickDesignChanged = new Subject<QuickDesign>();
  quickDesignOperation = new Subject<QuickDesign>();
  quickDesignBuild = new Subject<QuickDesign>();
  quickDesignDelete = new Subject<QuickDesign>();

  private quickDesigns: QuickDesign[] = [];

  constructor(@Inject(APP_CONFIG) private appConfig,
              private httpClient: HttpClient,
              private _http: Http,
              private authService: AuthService) {}

  setQuickDesigns(quickDesigns: QuickDesign[]) {
    this.quickDesigns = quickDesigns;
    this.quickDesignsChanged.next(this.quickDesigns);
  }

  getQuickDesigns() {
    return this.quickDesigns;
  }

  getIdIndex(id: number) {
    return this.quickDesigns.findIndex(c => c.ID === id);
  }

  httpGetQuickDesigns(params: any = [], columns: string = '', order: string = '') {

    let httpParams = new HttpParams();

    if ( columns ) {
      httpParams = httpParams.append('select', columns);
    }
    if ( order ) {
      httpParams = httpParams.append('order', order);
    }

    for (const p of Object.keys(params)) {
      httpParams = httpParams.append(p, params[p]);
    }

    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/quick-designs',
      {
        params: httpParams
      }
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: QuickDesign[]) => {
        this.setQuickDesigns(response);
      }
    );
  }

  httpGetQuickDesign(id: number) {
    const req = new HttpRequest(
      'GET',
      this.appConfig.API_ENDPOINT + '/quick-designs/' + id,
    );

    return this.httpClient.request(
      req
    )
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: QuickDesign) => {
        this.quickDesignChanged.next(response);
      }
    );
  }

  httpPostQuickDesign(data: Element) {
    const req = new HttpRequest(
      'POST',
      this.appConfig.API_ENDPOINT + '/quick-designs',
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            const responseData = response.body.data;
            const id = responseData.ID;

            if ( typeof data['iconFile'] !== 'undefined' ) {
              const icon = data['iconFile'];
              const formData = new FormData();

              if ( typeof icon !== 'undefined' ) {
                formData.append('icon', icon, icon.name);
              }

              const _headers = new Headers();

              _headers.append('Authorization', 'Bearer ' + this.authService.auth.__token);

              this._http.post(
                this.appConfig.API_ENDPOINT + '/quick-designs/upload/' + id,
                <any>formData,
                { headers: _headers }
              ).toPromise();
            }

            return responseData;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.quickDesignOperation.next(response);
      }
    );
  }

  httpPutQuickDesign(id: number, data: QuickDesign) {
    const req = new HttpRequest(
      'PUT',
      this.appConfig.API_ENDPOINT + '/quick-designs/' + id,
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            if ( typeof data['iconFile'] !== 'undefined' ) {
              const icon = data['iconFile'];
              const formData = new FormData();

              if ( typeof icon !== 'undefined' ) {
                formData.append('icon', icon, icon.name);
              }

              const _headers = new Headers();

              _headers.append('Authorization', 'Bearer ' + this.authService.auth.__token);

              this._http.post(
                this.appConfig.API_ENDPOINT + '/quick-designs/upload/' + id,
                <any>formData,
                { headers: _headers }
              ).toPromise();
            }

            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.quickDesignOperation.next(response);
      }
    );
  }

  httpBuildQuickDesign(id: number, data: QuickDesign) {
    const req = new HttpRequest(
      'PUT',
      this.appConfig.API_ENDPOINT + '/quick-designs/' + id + '/build',
      data
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (response.body) {
          if (response.body.status === 'success') {
            return response.body.data;
          }
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.quickDesignBuild.next(response);
      }
    );
  }

  httpDeleteQuickDesign(id: number) {
    const req = new HttpRequest(
      'DELETE',
      this.appConfig.API_ENDPOINT + '/quick-designs/' + id
    );

    return this.httpClient.request<any>(req)
    .map(
      (response: any) => {
        if (typeof response.body !== 'undefined' && response.body != null) {
            return response.body;
        }

        return [];
      }
    )
    .subscribe(
      (response: any) => {
        this.quickDesignDelete.next(response);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/quick-deisgn.service.ts